import { environment } from '../../environments/environment';

/**
 * Logging a developer wants and a member must never see.
 *
 * The client printed member data to the browser console in production: whole
 * memberships lists with names, numbers and bonus figures, ownerships with
 * addresses, the response of every membership lookup. Anyone with the page open
 * could read it, and anything that collects console output collected it too
 * (FIND-02, WO-33).
 *
 * Calls that carry something a developer would use go through here and are
 * silent in a production build. Calls that carried nothing were deleted. An
 * error a member should know about belongs in a toast, and one the host should
 * know about belongs in its own log, not here.
 */
export class LogService {
  static debug(...args: any[]): void {
    if (!environment.production) {
      // The one console call left in the client; the pull-request job fails on
      // any other (WO-33).
      console.log(...args);
    }
  }
}
